'use client';

import { useIntl } from 'react-intl';
import { PrimaryButton } from '../../components/PrimaryButton/PrimaryButton.client';
import { SampleOrderContent } from '../../components/SampleOrderContent/SampleOrderContent';
import type { AbortHandler, SetStep, SampleOrderMode } from '../../types';
import { SampleOrderSteps } from '../types';
import { ActionButtonsWrapper } from '../../components/ActionButtonsWrapper/ActionButtonsWrapper';

export type FinishedProps = SetStep &
  SampleOrderMode & {
    finishSampleOrderHandler: AbortHandler['abortHandler'];
  };

export const Finished = ({ setStep, mode, finishSampleOrderHandler }: FinishedProps) => {
  const { formatMessage } = useIntl();

  return (
    <SampleOrderContent
      pageContent={
        <div className="flex h-full w-full flex-col items-center justify-center">
          <div className="flex h-full w-full flex-col items-center lg:w-4/5">
            <div className="bg-color-success mx-auto mb-5 flex size-[7.5rem] flex-col items-center justify-center rounded-full">
              <span className="icon-emp-checkmark text-color-background-base size-[4.688rem]" />
            </div>
            <p className="text-size-h4 mb-1.5 text-center">
              {formatMessage({
                defaultMessage: 'Deine Musterbestellung wurde erfolgreich abgeschickt.',
                id: 'sampleOrder.finished.successHeader',
              })}
            </p>
            <p className="text-center">
              {formatMessage({
                defaultMessage: 'Du erhältst deine Muster in wenigen Tagen per Post.',
                id: 'sampleOrder.finished.successMessage',
              })}
            </p>
          </div>
        </div>
      }
      actionBarContent={
        mode === 'standalone' ? null : (
          <ActionButtonsWrapper
            primary={
              <PrimaryButton
                actionHandler={() => {
                  setStep(SampleOrderSteps.SelectSamples);
                  finishSampleOrderHandler();
                }}
                text={formatMessage({
                  defaultMessage: 'Zurück zum Produkt',
                  id: 'sampleOrder.finished.button.back',
                })}
              />
            }
          />
        )
      }
    />
  );
};
